import {useEffect, useState} from 'react';
import {useHistory} from 'react-router';

export const useAdsConsent = () => {
  const [adsConsent, setAdsConsent] = useState('pending');
  const history = useHistory();

  useEffect(() => {
    const checkForConsent = setInterval(() => {
      if (typeof window.__tcfapi === 'function') {
        clearInterval(checkForConsent);
        window.__tcfapi('addEventListener', 2, tcData => {
          if (tcData.vendor.consents[755]) {
            setAdsConsent('success');
          } else {
            setAdsConsent('failure');
          }
          if (tcData.eventStatus === 'tcloaded' || tcData.eventStatus === 'useractioncomplete') {
            // Remove '#cmpscreen when cmp is closed again (enable it to get opened again)
            if (window.location.href.includes('#cmpscreen')) history.replace(history.location.pathname);
          }
        });
      }
    }, 50);
  }, []);

  return adsConsent;
};
